<h2 mat-dialog-title></h2>
<mat-dialog-content class="mat-typography permitted-or-not-dialog">
  <div>
    <div fxLayout="row" fxLayoutAlign="center">
      <mat-card fxFlex="90">
        <mat-card-content>
          <div class="images-container">
            <div class="sub-section-wrapper">
              <div class="faqTitle">
                <h4>Click 'Confirm' to <span class="bold">{{documentMessage}}:</span> </h4>
              </div>
              <div>
                <ng-container *ngIf="documentTitle">
                  <div class="bold m-1-0">
                    {{documentTitle}}
                  </div>
                  </ng-container>
              </div>
            </div>
              <div class="sub-section-wrapper">
                <button mat-raised-button type="button" color="warn" class="ldb-bg ldo-txt form-btn"
                  (click)="deleteRecordFn()">Confirm
                </button>
              </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="closeDialog()" mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
